import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import { isMobile } from '../utilities/breakpoints';

const { processAlertMessage } = require('../accessibility/accessibilityHelper');

$(document).ready(function () {
    $('.shoppable-section .shoppable-section__carousel').each(function () {
        if (isMobile()) {
            const $carousel = $(this);
            const slideCount = $carousel.find('.swiper-slide').length;

            const showControls = slideCount > 2;

            new Swiper(this, {
                modules: [Navigation, Pagination],
                slidesPerView: 1.8,
                centeredSlides: false,
                loop: false,
                navigation: showControls ? {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                } : false,
                pagination: showControls ? {
                    el: ".swiper-pagination",
                    clickable: true,
                } : false,
                on: {
                    slideChangeTransitionEnd(swiper) {
                        processAlertMessage('Showing shoppable carousel slide ' + (swiper.realIndex + 1), true);
                    }
                }
            });

            if (!showControls) {
                $carousel.find('.swiper-pager').remove();
            }
        }
    });
});